import type { FormField, FormInitialValues } from '../typings';

export type ActiveFieldDeclaration = {
  message: string;
  /** fieldId of the checkbox the alert renders under. */
  anchorFieldId: string;
};

/**
 * Every declaration the group's fields currently trigger, one per distinct
 * message. Two fields carrying the same copy collapse to a single alert below
 * the later of them, so a block with two Unlimited toggles states it once.
 */
export const findFieldDeclarations = (
  fields: FormField[] | undefined,
  values: FormInitialValues,
): ActiveFieldDeclaration[] => {
  if (!fields?.length) return [];

  const anchorByMessage = new Map<string, string>();

  for (const field of fields) {
    const declaration = 'declaration' in field ? field.declaration : undefined;

    if (!declaration) continue;

    // An untouched checkbox holds no value; unticked reads as false, matching
    // how RequiredWhenValueRestriction.IsSatisfied reads the same control.
    if ((values[field.fieldId] ?? false) !== declaration.showWhenBoolEquals) continue;

    // Last writer wins, so a shared message anchors below every field carrying it.
    anchorByMessage.set(declaration.message, field.fieldId);
  }

  return [...anchorByMessage].map(([message, anchorFieldId]) => ({
    message,
    anchorFieldId,
  }));
};
